import CartItem from "./CartItem";
import {DateTime} from "luxon";

class TourItem  extends CartItem {

    constructor(item, amount = 1) {
        item.bike_types = item.bike_types.map(i => {
            i.amount = 0;
            i.insuranceAmount = 0;

            return i;
        });


        item.bike_types[0].amount = 1;
        super(item, amount);

        this.slot = {
            date: DateTime.now(),
            time: item.time_slots.length ? new DateTime.fromFormat(item.time_slots[0], 'yyyy-MM-dd HH:mm').toFormat('HH:mm') : null
        }
    }
}

export default TourItem
